import { render, staticRenderFns } from "./OnlineStore.vue?vue&type=template&id=fc5e83a0&scoped=true&"
import script from "./OnlineStore.vue?vue&type=script&lang=js&"
export * from "./OnlineStore.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStore.vue?vue&type=style&index=0&id=fc5e83a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5e83a0",
  null
  
)

export default component.exports